module.exports = __webpack_public_path__ + "static/media/search.11a49aa5.svg";